// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3SNkE","tab":"Tabs_tab__3ZOVX","tabActive":"Tabs_tabActive__2hCm7"};